import { render, staticRenderFns } from "./HotelsBuyNowButton.vue?vue&type=template&id=193f0cf4&scoped=true&"
import script from "./HotelsBuyNowButton.vue?vue&type=script&lang=ts&"
export * from "./HotelsBuyNowButton.vue?vue&type=script&lang=ts&"
import style0 from "./HotelsBuyNowButton.vue?vue&type=style&index=0&id=193f0cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193f0cf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('193f0cf4')) {
      api.createRecord('193f0cf4', component.options)
    } else {
      api.reload('193f0cf4', component.options)
    }
    module.hot.accept("./HotelsBuyNowButton.vue?vue&type=template&id=193f0cf4&scoped=true&", function () {
      api.rerender('193f0cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Availability/view/vue/components/buttons/HotelsBuyNowButton.vue"
export default component.exports